import { Injectable } from '@angular/core';
import { TranslateService, LangChangeEvent } from '@ngx-translate/core';
import * as moment from 'moment';
import { LANG_KEY } from '../../../shared/constants/app.constants';
import { StorageService } from './storage.service';

@Injectable({ providedIn: 'root' })
export class I18nService {

  defaultLanguage: string;
  supportedLanguages: string[];

  constructor(private translateService: TranslateService, private storageService: StorageService) {
    // Embed languages to avoid extra HTTP requests
    // translateService.setTranslation('en-US', enUS );
    //translateService.setTranslation('fr-FR', frFR);
  }

  /**
   * Initializes i18n for the application.
   * Loads language from local storage if present, or sets default language.
   * @param {!string} defaultLanguage The default language to use.
   * @param {Array.<String>} supportedLanguages The list of supported languages.
   */
  init(defaultLanguage: string, supportedLanguages: string[]) {
    this.defaultLanguage = defaultLanguage;
    this.supportedLanguages = supportedLanguages;
    this.language = null;

    this.translateService.onLangChange
      .subscribe((event: LangChangeEvent) => {
        this.storageService.setItem(LANG_KEY, event.lang);
      });
  }

  /**
   * Sets the current language.
   * Note: The current language is saved to the local storage.
   * If no parameter is specified, the language is loaded from local storage (if present).
   * @param {string} language The IETF language code to set.
   */
  set language(language: string) {
    language = language || this.storageService.getItem(LANG_KEY) || this.translateService.getBrowserCultureLang();
    let isSupportedLanguage = this.supportedLanguages.indexOf(language) !== -1;

    // If no exact match is found, search without the region
    if (language && !isSupportedLanguage) {
      //language = language.split('-')[0];
      language = this.supportedLanguages.find(supportedLanguage => supportedLanguage.startsWith(language));
      isSupportedLanguage = Boolean(language);
    }

    // Fallback if language is not supported
    if (!isSupportedLanguage) {
      language = this.defaultLanguage;
    }

    // set moment locale
    moment.locale(language);

    // log.debug(`Language set to ${language}`);
    this.translateService.use(language);
  }

  /**
   * Gets the current language.
   * @return {string} The current language code.
   */
  get language(): string {
    return this.translateService.currentLang;
  }

}
